import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  searchBtn: {
    marginLeft: 10,
  },
});

export default useStyles;